import { toast } from "react-toastify";
import axios from 'axios';

import { client } from "../helpers/client";
import { nap } from "./generalUtils";


// ## LOGIN

const onSignatureSuccess = async ({ user, response, message, resolve }) => {
  // ## Keychain signature success
  console.log('Keychain requestSignBuffer:', user, response);
  if (response.error) {
    const errMsg = 'Keychain signing failed';
    console.log(errMsg, response.error);
    toast.error(errMsg);
    return resolve({ err: errMsg });
  }
  // ## Verification API request
  let resHiveUserVerify;
  try {
    resHiveUserVerify = await client.post('/api/auth/verify',
      { username: user, message, signed_message: response.result },
    );
  } catch (err) {
    alert('Unable to authenticate. Are you on a stable connection? Trying again in 30 seconds..');
    await nap(30 * 1000);
    resHiveUserVerify = await client.post('/api/auth/verify',
      { username: user, message, signed_message: response.result },
    );
  }
  if (resHiveUserVerify.status !== 200 || resHiveUserVerify.data.result !== 'success') {
    toast.error('Uh oh, something went wrong authenticating your signature');
    return resolve({ err: 'api verification ko' });
  }
  // ## Set JWT header
  const headerValue = `Bearer ${resHiveUserVerify.data.token}`;
  axios.defaults.headers.common['Authorization'] = headerValue;
  resolve({});
};

export const authenticateWithBE = ({ user }) => new Promise((resolve) => {
  const message = `${user}_${Date.now()}`;
  window.hive_keychain.requestSignBuffer(
    user,
    message,
    'Posting',
    (response) => onSignatureSuccess({ user, response, message, resolve }),
  )
});


// ## GET PACK CONTENTS FROM BACKEND

export const sendTxAndBlockToBE = async ({ user, tx, block }) => {
  try {
    // CREATE USER IF DOES NOT EXIST
    let testCallResp;
    try {
      testCallResp = await client.post('/api/user/get',
        { account: user },
        { timeout: 2 * 60 * 1000 },
      );
    } catch (err) {
      alert('Unable to lookup your identity. Are you on a stable connection? Trying again in 30 seconds..');
      await nap(30 * 1000);
      testCallResp = await client.post('/api/user/get',
        { account: user },
        { timeout: 2 * 60 * 1000 },
      );
    }
    if (testCallResp.status > 300) {
      console.error('account creation/lookup call fail:', { testCallResp });
      toast.error('Uh oh, something went wrong looking up your account');
      return ({ err: 'something broke looking up your identity' });
    } else { console.log('LFG >>>> []', { testCallResp }); }
  } catch (err) {
    console.error('Caught error during account creation/lookup:', err);
    return({ err: `Caught during account creation/lookup: ${err} - ${JSON.stringify(err)}` });
  }
  try {
    // SEND OPEN PACK REQUEST TO API
    let claimPackResp;
    try {
      claimPackResp = await client.post('/api/hive/pack-open',
        { account: user, trxId: tx, blockNum: block },
      );
      // handleDeprecatedClient();
    } catch (err) {
      alert('Unable to process your transaction. Are you on a stable connection? Trying again in 30 seconds..');
      await nap(30 * 1000);
      claimPackResp = await client.post('/api/hive/pack-open',
        { account: user, trxId: tx, blockNum: block },
      );
    }
    if (claimPackResp.status !== 200) {
      toast.error('Uh oh, something went wrong claiming your pack');
      return ({ err: 'nft claim failed' });
    }
    console.log('pack nft claim success');
    return ({});
  } catch (err) {
    console.error('Caught error during pack opening:', err);
    return({ err: `Caught during pack opening: ${JSON.stringify(err?.response?.data || err.message)}
      ${Object.keys(err)}
      ${err}` });
  }
};


// export const handleDeprecatedClient = (data = {}) => {
//   // {
//   //   error: `You are using a deprecated version of our website (${clientVersion}).
//   //     Please clear your browser cache and try again.`,
//   //   deprecated: true,
//   // }
//   const { deprecated, error } = data;
//   isLocal && console.debug('[depre] checking for deprecation msg:', { data, deprecated, error });
//   if (deprecated) {
//     window.alert(error);
//     throw new Error('deprecated-client');
//   }
//   return data;
// };
